"use client";

import { Button } from "@/components/ui/button";
import { Loader2, KeyRound } from "lucide-react";

interface PasskeySignInButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  className?: string;
}

export function PasskeySignInButton({
  onClick,
  isLoading = false,
  className = "",
}: PasskeySignInButtonProps) {
  return (
    <Button
      type="button"
      variant="outline"
      className={`w-full ${className}`}
      onClick={onClick}
      disabled={isLoading}
    >
      {isLoading ? (
        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
      ) : (
        <KeyRound className="mr-2 h-4 w-4" />
      )}
      Sign in with a passkey
    </Button>
  );
}
